import { Box, Grid, Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import React from 'react';
import StatBox from 'components/StatBox';
import { useGetExpenseCardStatsQuery } from 'state/api';

const Cards = () => {
  const { data, isLoading } = useGetExpenseCardStatsQuery();
  return (
    <Box
      sx={{
        m: 2,
        ml: 0,
      }}
    >
      <Grid container spacing={4} className='flex justify-start'>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            // card to display expenses for the month
            title='Expense for the Year'
            value={isLoading ? '-' : '₹ ' + data?.totalExpenseAmountInYear}
            icon={
              <Typography className='font-extrabold' variant='h5'>
                ₹
              </Typography>
            }
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Expense for the Month'
            value={isLoading ? '-' : '₹ ' + data?.totalExpenseAmountInMonth}
            icon={
              <Typography className='font-extrabold' variant='h5'>
                ₹
              </Typography>
            }
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
          className='text-[#1F509A] border border-[#1F509A]'
            title='Expense Count for the Year'
            value={isLoading ? '-' : data?.totalExpenseCountInYear}
            icon={<CreditCardIcon />}
            color='#D4EBF8'
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Cards;
